/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef, type ReactNode, type Ref } from 'react';

import { cssMap, jsx } from '@compiled/react';

import { Box } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		listStyleType: 'none',
		margin: token('space.0', '0'),
	},
});

export const MenuListItem = forwardRef<HTMLLIElement, MenuListItemProps>(_MenuListItem);

function _MenuListItem({ children }: MenuListItemProps, ref: Ref<HTMLLIElement>) {
	return (
		<Box as="li" xcss={styles.root} ref={ref}>
			{children}
		</Box>
	);
}

type MenuListItemProps = {
	children: ReactNode;
};
